import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../services/user';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {

  constructor(private _userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredAccess = route.data['accessPage'];

    return this._userService.getAccountType().pipe(
      map((data: any) => {
        const accessPages = data['access_pages'] ?? [];
        const userType = String(data['user_type'] ?? '');

        if (userType === '10') {
          return true;
        }

        if (Array.isArray(accessPages) && accessPages.includes(requiredAccess)) {
          return true;
        }

        return this.router.createUrlTree(['/no-data']);
      }),
      catchError((error) => {
        console.error('Guard error:', error);
        return of(this.router.createUrlTree(['/no-data']));
      })
    );
  }
}
